import axios from "axios";

export const mainRequest = {
    checkIfUserWinner: ({ userAccount }) => {
        return axios.post('https://r5t68qyb1a.execute-api.us-east-1.amazonaws.com/prod/winner/verify', {
            userAccount
        });
    }
};